/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// @ts-nocheck
import PopupInputCode from "components/popup-input-code";
import PopupMessage from "components/popup-message";
import PopupOtp from "components/popup-otp";
import { urlAssetsCustom } from "utils/common";
import {
  BOX_GIFT_GIFTID,
  BUSINESS_ACCOUNT_ID,
  CAMPAIGNID,
  CARD10K_GIFTID,
  END_DATE,
  END_DATE_TIME,
  GOLD_GIFTID,
  GOOD_LUCK_GIFTID,
  HOTLINE as Hotline,
  SAAS_CAMPAIGNID,
  START_DATE,
  START_DATE_TIME,
  TENANTID,
  TICKET_GIFTID,
} from "constants/common";
import moment from "moment";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import actions from "redux/home/actions";
import actionsPrize from "redux/prize/actions";
import HomePageView from "./view";
import { signInWithCustomToken, getAuth } from "firebase/auth";
import LoadingSpinner from "components/LoadingSpinner";
import PopupGiftTopup from "components/popup-gift-topup";
import PopupNoGift from "components/popup-no-gift";
import { checkPhoneNetwork } from "utils";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import { toast } from "react-toastify";
import PopupGiftPhycial from "components/popup-gift-phycial";
import PopupGiftSuccess from "components/popup-gift-success";

const HomePage = () => {
  const navigate = useNavigate();
  const myRef = useRef(null);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    getValues,
    reset,
  } = useForm();
  const cookies = new Cookies();
  const dispatch = useDispatch();

  const [provinces, setProvinces] = useState([]);
  const [provinceSelected, setProvinceSelected] = useState(null);

  const [modal, setModal] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [modalInput, setModalInput] = useState(false);
  const [content, setContent] = useState("");
  const [otp, setOtp] = useState("");
  const [isErrorOTP, setIsErrorOTP] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPopupGiftPhycial, setIsShowPopupGiftPhycial] = useState(false);
  const [code, setCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [address, setAddress] = useState("");
  const [OtpRequestTime, setOtpRequestTime] = useState("");
  const [OtpResponseTime, setOtpResponseTime] = useState("");
  const [dataSubmit, setDataSubmit] = useState({});
  const [nameBtn, setNameBtn] = useState("");
  const [nameBtn1, setNameBtn1] = useState("");
  const [nameBtn2, setNameBtn2] = useState("");
  const [timerId, setTimerId] = useState(null);
  const [dataModalTopup, setDataModalTopup] = useState({});
  const [isErrorPhoneNumber, setIsErrorPhoneNumber] = useState(false);
  const [isErrorCode, setIsErrorCode] = useState(false);
  const [networkPhone, setNetworkPhone] = useState("");
  const [isCommingSoon, setCommingSoon] = useState(true);
  const isEnableButton = useRef(false);
  const [isAgree, setIsAgree] = useState(false);
  const HOTLINE = `<span>${Hotline}</span>`;
  const [searchParams] = useSearchParams();
  const { state } = useLocation();
  const [dataGift, setDataGift] = useState({});
  const [scrollToElement, setScroolToElement] = useState(null);
  localStorage.removeItem("rule");

  const [remaining, setRemaining] = useState(null);
  const isUserUsingMobile = () => {
    // Screen resolution method
    let screenWidth = window.screen.width;
    return screenWidth < 992;
  };

  const handleScroll = (node) => {
    node.scrollIntoView({ behavior: "smooth" });
  };

  const location = useLocation();

  const handleScroolToElementAction = (elementId) => {
    if (location.pathname !== "/") {
      navigate("/");
      setScroolToElement(elementId);

      return;
    }
    handleScroll(document.getElementById(elementId));
  };

  useEffect(() => {
    var a = localStorage.getItem("scroolToElement");
    setScroolToElement(a);
    !!scrollToElement && handleScroll(document.getElementById(scrollToElement));
    // setScroolToElement(null);
  }, [scrollToElement]);
  useEffect(() => {
    $(window).scrollTop(0);
    if (state?.scrollToJoin) {
      $("html, body").scrollTop($("#guide_join").offset().top);
      let test = setInterval(() => {
        const ctaWelcomeElement = document.getElementById("guide_join");
        const offsetTopGuide = ctaWelcomeElement.offsetTop;
        console.log("window.scrollY >>>", window.scrollY);
        console.log("window.offsetTopGuide >>>", offsetTopGuide);
        console.log("guide.top >>>", $("#guide_join").offset().top);

        if (window.scrollY < offsetTopGuide) {
          $("html, body").scrollTop($("#guide_join").offset().top);
        } else {
          clearInterval(test);
        }
      }, 500);
    }
  }, [state]);
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      let isErr = false;

      if (name === "phone") {
        if (
          value?.phone?.startsWith("0") &&
          !["00", "01", "02", "04", "06"].includes(value.phone.substr(0, 2)) &&
          value.phone.length === 10 &&
          parseInt(value.phone) > 0
        ) {
          setIsErrorPhoneNumber(false);
        } else {
          setIsErrorPhoneNumber(true);
        }
      }
      if (name === "code") {
        if (value.code.length === 10) {
          setIsErrorCode(false);
        } else {
          setIsErrorCode(true);
        }
      }

      if (
        value?.fullName &&
        value?.phone?.trim()?.length === 10 &&
        value?.isAgree && !isErrorPhoneNumber 
        && value?.provinces
        
      ) {
        removeDisableBtn("#btn-register");
      } else {
        addDisableBtn("#btn-register");
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);



  const hideModal = () => {
    setModal(false);
    setContent("");
    setNameBtn("");
    setNameBtn1("");
    setNameBtn2("");
    document.body.classList.remove("modal-open");
  };

  const hideModalComfirm = () => {
    setModal(false);
    setIsShowModalNoGift(false);
    setIsShowModalTopup(false);
    setIsShowPopupGiftPhycial(false);
    setIsShowPopupGiftSuccess(false);
    document.body.classList.remove("modal-open");
  };

  const startTimer = () => {
    if (timerId) clearTimeout(timerId);
    setTimerId(setTimeout(hideModal, 10000));
  };

  const stopTimer = () => clearTimeout(timerId);

  const removeModalOpen = () => {
    setIsLoading(false);
    document.body.classList.remove("modal-open");
  };

  useEffect(() => {
    if (!modalOtp) {
      setOtp("");
      setIsErrorOTP(false);
      clearField();
    }
  }, [modalOtp]);

  useEffect(() => {
    document.body.classList.add("home-page");
    return stopTimer;
  }, []);

  useEffect(() => {
    if (otp.length === 6) {
      handleSubmitOTP();
    }
  }, [otp]);

  useEffect(() => {
    validateCampaign();
    getMartsCampaign();
    getProvinces();
  }, []);
  const checkError = (err) => {
    let content = "";
    switch (err) {
      
      case "PhoneNumberAlreadyRedeemed":
       content = `<h5>  THÔNG BÁO  </h5>
        <p>Quý khách đã nhận quà từ chương trình,<br/>
vui lòng quay lại vào lần sau</p>`;
        setNameBtn(`VỀ TRANG CHỦ`);
        break;
      case "InvalidOtp":
              setIsErrorOTP(true);
              setIsLoading(false);
              setModal(false);
              break;
     case "GiftOutOfStock":
       content = `<h5>  THÔNG BÁO  </h5>
        <p>Hiện tại chương trình đã hết quà,<br/>
vui lòng quay lại vào chương trình sắp tới</p>`;
        setNameBtn(`VỀ TRANG CHỦ`);
        break;
 case "DailyGiftQuotaExceeded":
       content = `<h5>  THÔNG BÁO  </h5>
        <p>Hiện tại chương trình đã phát hết số quà trong ngày, vui lòng quay lại vào ngày mai</p>`;
        setNameBtn(`VỀ TRANG CHỦ`);
        break;

        
        case "CampaignNotFound":
       content = `<h5>  THÔNG BÁO  </h5>
 <p>Ngoài thời gian diễn ra chương trình. Quý khách vui lòng quay lại sau! <br/> LH Hotline ${HOTLINE} để được hỗ trợ (1.000d/phút)</p>`;


        setNameBtn(`VỀ TRANG CHỦ`);
        break;
         case "CampaignNotActive":
       content = `<h5>  THÔNG BÁO  </h5>
        <p>Chương trình chưa bắt đầu. Quý khách vui lòng quay lại sau! <br/> LH Hotline ${HOTLINE} để được hỗ trợ (1.000d/phút)</p>`;

        setNameBtn(`VỀ TRANG CHỦ`);
        break;
      default:
        content = `<h5>  THÔNG BÁO  </h5>
                
        <p>Đã có lỗi xảy ra trong quá trình kết nối. Vui lòng kiểm tra lại! <br/> LH Hotline ${HOTLINE} để được hỗ trợ (1.000d/phút)</p>`;
        setNameBtn(`ĐÓNG`);
        break;
    }
    if(err !== "InvalidOtp"){
    showModal();
    setContent(`${content}`);
    }
  };
  const onSuccessExchangeCode = (data) => {
    setIsLoading(false);
    let content = "";
    switch (data?.data?.rewardId) {
      case GOOD_LUCK_GIFTID:
        content = `<h5>CHÚC BẠN MAY MẮN LẦN SAU</h5> 
                <img
                  className="img-modal"
                  src=${urlAssetsCustom("assets/img/icon/good-luck.png")}
                />
      <p>Cảm ơn bạn đã tham gia chương trình</p>`;
        setNameBtn(`ĐÓNG`);
        break;
      case CARD10K_GIFTID:
        content = `<h5>CHÚC MỪNG BẠN ĐÃ NHẬN ĐƯỢC</h5> 
                <img
                  className="img-modal"
                  src=${urlAssetsCustom("assets/img/md_card10.png")}
                />
      <p>Chúc mừng bạn đã nhận thẻ cào điện thoại trị giá 10.000đ được nạp trực tiếp vào số điện thoại đăng ký.</p>`;
        setNameBtn(`ĐÓNG`);
        break;
      case TICKET_GIFTID:
        setDataGift({
          giftName:
            "02 voucher Viettravel đi du lịch Hàn Quốc tổng trị giá 40.000.000 đồng",
          giftImg: urlAssetsCustom("assets/img/md_ticket.png"),
        });
        content = `<h5>CHÚC MỪNG BẠN ĐÃ NHẬN ĐƯỢC</h5> 
                <img
                  className="img-modal"
                  src=${urlAssetsCustom("assets/img/md_ticket.png")}
                />
                <strong>02 voucher Viettravel đi du lịch Hàn Quốc tổng trị giá 40.000.000 đồng
</strong> <br/> <br/>
      <p>Chúc mừng quý khách trúng thưởng từ chương trình. Vui lòng giữ lại phần nắp kem có chứa mã số trúng thưởng và tin nhắn thông báo trúng thưởng từ chương trình để làm bằng chứng trúng thưởng. <br/> LH Hotline ${HOTLINE} để được hỗ trợ (1.000d/phút).</p>`;
        setNameBtn(`NHẬP THÔNG TIN NHẬN QUÀ`);
        break;
      case GOLD_GIFTID:
        setDataGift({
          giftName: "01 chỉ vàng PNJ 24k",
          giftImg: urlAssetsCustom("assets/img/md_gold.png"),
        });
        content = `<h5>CHÚC MỪNG BẠN ĐÃ NHẬN ĐƯỢC</h5> 
                <img
                  className="img-modal"
                  src=${urlAssetsCustom("assets/img/md_gold.png")}
                />
                <strong>01 chỉ vàng PNJ 24k</strong> <br/> <br/>
      <p>Chúc mừng quý khách trúng thưởng từ chương trình. Vui lòng giữ lại phần nắp kem có chứa mã số trúng thưởng và tin nhắn thông báo trúng thưởng từ chương trình để làm bằng chứng trúng thưởng.  <br/> LH Hotline ${HOTLINE} để được hỗ trợ (1.000d/phút).</p>`;
        setNameBtn(`NHẬP THÔNG TIN NHẬN QUÀ`);
        break;
      case BOX_GIFT_GIFTID:
        setDataGift({
          giftName: "01 Hộp quà giới hạn Cornetto x Cha Eun-Woo",
          giftImg: urlAssetsCustom("assets/img/cornetto-box-gift.png"),
        });
        content = `<h5>CHÚC MỪNG BẠN ĐÃ NHẬN ĐƯỢC</h5> 
                <img
                  className="img-modal"
                  src=${urlAssetsCustom("assets/img/cornetto-box-gift.png")}
                />
                <strong>01 Hộp quà giới hạn Cornetto x Cha Eun-Woo</strong> <br/> <br/>
      <p>Chúc mừng quý khách trúng thưởng từ chương trình. Vui lòng giữ lại phần nắp kem có chứa mã số trúng thưởng và tin nhắn thông báo trúng thưởng từ chương trình để làm bằng chứng trúng thưởng. <br/> LH Hotline ${HOTLINE} để được hỗ trợ (1.000d/phút).</p>`;
        setNameBtn(`NHẬP THÔNG TIN NHẬN QUÀ`);
        break;
      default:
        break;
    }
    showModal();
    setContent(`${content}`);
  };

  const validateCampaign = () => {
    setIsLoading(true);
    localStorage.setItem("accessToken", "");
    dispatch(
      actions.CHECK_CAMPAIGN.request(
        {},
        (res) => {
          setIsLoading(false);
        },
        (err) => {
          setIsLoading(false);
          checkError(err?.data?.errorCode);
        }
      )
    );
  };
    const getMartsCampaign = () => {
    setIsLoading(true);
    dispatch(
      actions.GET_MARTS.request(
        {},
        (res) => {
          setIsLoading(false);
          let total = Array.from(String(res.gifts?.[0]?.allocatedQuantity).padStart(6, '0'), Number)
          setRemaining(total);
        },
        (err) => {
          setIsLoading(false);
          checkError(err?.data?.errorCode);
        }
      )
    );
  };
  
const getProvinces = () => {
    setIsLoading(true);
    localStorage.setItem("accessToken", "");
    dispatch(
      actions.GET_PROVINCES.request(
        {},
        (res) => {
         const provinceOptions = res.map((item) => ({
          value: item.code,
          label: item.city
          }));
          setIsLoading(false);
          setProvinces(provinceOptions);
        },
        (err) => {
          setIsLoading(false);
          checkError(err);
        }
      )
    );
  };
  

  const showModal = () => {
    setModal(true);
    document.body.classList.add("modal-open");
  };
  const closeModalOTP = () => {
    setModalOtp(false);
    setOtp("");
    setIsErrorOTP(false);
    document.body.classList.remove("modal-open");
    removeDisableBtn("#btn-register");
  };

  const onSubmit = (data) => {
    if (isEnableButton.current) {
      localStorage.setItem("formData", JSON.stringify(data));
      handleCheckPhone(data);

      document.body.classList.add("modal-open");
      addDisableBtn("#btn-register");
      setDataSubmit(data);
    }
  };

  const addDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.add("disabled");
    isEnableButton.current = false;
  };

  const removeDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.remove("disabled");
    isEnableButton.current = true;
  };

  const handleSubmitOTP = () => {
    setIsLoading(true);
    verifyOTP();
  };

  const resendOTP = () => {
    setIsErrorOTP(false);
    setOtp("");
    requestOTP(dataSubmit);
  };

  const clearField = (type) => {
    addDisableBtn("#btn-register");
    setIsErrorPhoneNumber(false);
    switch (type) {
      case "all":
        setValue("code", "");
        setValue("isAgree", false);
        setValue("phone", "");
        break;

      case "success":
        setValue("code", "");
        setValue("isAgree", false);
        break;

      default:
        setValue("isAgree", false);
        break;
    }
  };

  const verifyOTP = () => {
    const saved = localStorage.getItem("formData");

      if (!saved) {
      console.error("formData not found in storage");
      return;
      }

      const formData = JSON.parse(saved);
    dispatch(
      actions.VERIFY_OTP.request(
        {
          otpCode: otp,
          phoneNumber: phoneNumber,
          fullName: formData.fullName,
          province: formData.provinces?.label,

        },
        (res) => {
          // setIsLoading(false);
          removeModalOpen();
          setModalOtp(false);
          localStorage.setItem("giftData", JSON.stringify(res));
          navigate("/verifi-success")
          // requestLogin(res?.token?.accessToken);
        },
        (err) => {
          setIsLoading(false);
          clearField();
          const errorCode = err?.data?.errorCode;

          var errorMessage = "";
          checkError(errorCode);
         
         
        }
      )
    );
  };
  const handleCheckPhone = (data) => {
    setIsLoading(true);
    dispatch(
      actions.CHECK_PHONE.request(
        { phoneNumber: data.phone },
        (res) => {
          setIsLoading(false);
          requestOTP(data);
        },
        (err) => {
          setIsLoading(false);
          checkError(err?.data.errorCode);
          clearField();
        }
      )
    );
  };
  const clearFieldFormData = (type) => {
    let tmp = localStorage.getItem("formData");
    tmp = tmp ? JSON.parse(tmp) : {};
    switch (type) {
      case "fullName":
        delete tmp.fullName;
        setValue("fullName", "");
        break;

      case "phone":
        delete tmp.phone;
        setValue("phone", "");
        break;
      case "provinces":
        delete tmp.phone;
        setValue("provinces", "");
        break;

      default:
        break;
    }
    localStorage.setItem("formData", JSON.stringify(tmp));
  };

  const requestLogin = (customToken) => {
    setIsLoading(true);
    signInWithCustomToken(getAuth(), customToken)
      .then((authCredential) => {
        let user = authCredential?.user;

        localStorage.setItem("accessToken", user.accessToken || "");
        dispatch(
          actions.EXCHANGE_CODE.request(
            { code, otp },
            onSuccessExchangeCode,
            (err) => {
              setIsLoading(false);
              checkError(err);
            }
          )
        );
      })
      .catch((error) => {
        removeModalOpen();
      });
  };

  const isValidPhone = (phone) => {
    var vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;
    return vnf_regex.test(phone) ? true : false;
  };

  const showDefaultErrModal = () => {
    showModal();
    setNameBtn(`ĐÓNG`);
    setContent(
      `<h5>
              <img height={40} src="assets/img/logoFOOD.png" /> <br />
              THÔNG BÁO
            </h5><p>Đã có lỗi xảy ra!<br/></p>`
    );
  };

  const requestOTP = (data) => {
    setIsLoading(true);
    setOtpRequestTime(moment().utc().format());
    localStorage.setItem("accessToken", "");
    dispatch(
      actions.REQUEST_OTP.request(
        {
          phoneNumber: data.phone,
        },
        (res) => {
          setIsLoading(false);

          setOtpResponseTime(moment().utc().format());
          setCode(data.code);
          setPhoneNumber(data.phone);

          setModalOtp(true);
          removeModalOpen();
        },
        (err) => {
          setIsLoading(false);
          const errorCode = err?.data?.errorCode;
          var errorMessage = "";
          switch (errorCode) {
            case "InvalidResendTime":
              errorMessage = `<h5>  THÔNG BÁO  </h5><p>Yêu cầu gửi mã OTP của bạn đang được chúng tôi xử lý, bạn hãy thử lại sau 1 phút nhé.<p/>`;
              setNameBtn(`ĐÓNG`);
              break;

            default:
              errorMessage = `<h5>  THÔNG BÁO  </h5><p>Đã xảy ra lỗi xác thực, Quý khách vui lòng thử lại sau.<p/>`;
              setNameBtn(`ĐÓNG`);
              break;
          }
          if (errorMessage?.trim()?.length > 0) {
            setModal(true);
            setContent(errorMessage);
          }
          clearField();
          removeModalOpen();
        }
      )
    );
  };

  const clickAction = () => {
    
    hideModal();
    closeModalOTP();
    navigate("/");

  };

  return (
    <div
      onClick={() => {
        if (modalOtp) {
          hideModal();
        }
      }}
    >
      <LoadingSpinner isLoading={isLoading} />
      <HomePageView
        provinces={provinces}
        provinceSelected={provinceSelected}
        setProvinceSelected={setProvinceSelected}
        register={register}
        remaining={remaining}
        handleScroolToElementAction={handleScroolToElementAction}
        setValue={setValue}
        getValues={getValues}
        handleSubmit={handleSubmit(onSubmit)}
        isErrorPhoneNumber={isErrorPhoneNumber}
        isErrorCode={isErrorCode}
        isCommingSoon={isCommingSoon}
        clearFieldFormData={clearFieldFormData}
        isUserUsingMobile={isUserUsingMobile}
      />
      {modalOtp && (
        <PopupOtp
          setModal={setModalOtp}
          setOtp={setOtp}
          otp={otp}
          handleSubmitOTP={handleSubmitOTP}
          closeModalOTP={closeModalOTP}
          resendOTP={resendOTP}
          isErrorOTP={isErrorOTP}
          isLoading={isLoading}
        />
      )}

      {modal && (
        <PopupMessage
          nameBtn={nameBtn}
          nameBtn1={nameBtn1}
          nameBtn2={nameBtn2}
          setModal={setModal}
          content={content}
          clickAction={clickAction}
          clickAction1={clickAction}
          clickAction2={clickAction}
        />
      )}
      {isShowPopupGiftPhycial && (
        <PopupGiftPhycial
          dataGift={dataGift}
          code={code}
          setIsShowPopupGiftPhycial={setIsShowPopupGiftPhycial}
          setIsLoading={setIsLoading}
          checkError={checkError}
        />
      )}
    </div>
  );
};

export default HomePage;
